export class VpcCondition {
    'operator';
    'vpcs';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "operator",
            "baseName": "operator",
            "type": "ScalarOperators",
            "format": ""
        },
        {
            "name": "vpcs",
            "baseName": "vpcs",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return VpcCondition.attributeTypeMap;
    }
    constructor() {
    }
}
